module.exports = __webpack_public_path__ + "52cfd5a9be801d311c5eea3e7aa81b51.svg";